/**
 * @generated SignedSource<<960f5b75d7fed72cfbcba5b8452f1a5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespSearchResultContainer_user$data = {
  readonly hasMerchandizingPermission: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_user" | "useMeasurementUnit_user">;
  readonly " $fragmentType": "SbRespSearchResultContainer_user";
};
export type SbRespSearchResultContainer_user$key = {
  readonly " $data"?: SbRespSearchResultContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespSearchResultContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespSearchResultContainer_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": "hasMerchandizingPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "BUYER_FE_MERCH_TOOL"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMeasurementUnit_user"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "showMerchandizingTool",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "SharedItemTile_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b9aaacfda8f6bac698b0eeaf4dc7ceb3";

export default node;
